/**
 * Ein paar Standard-Mimetypes für's Web, bei Bedarf bitte erweitern
 */

const mimetype2suffix: Record<string, string> = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/webp": "webp",
};

const suffix2mimetype: Record<string, string> = {
  png: "image/png",
  jpg: "image/jpeg",
  webp: "image/webp",
};

/**
 * Gibt den Mimetype zu einem Dateinamen zurück
 * @param {string} filename
 * @returns {string}
 */
export const getMimetypeOfFilename = (filename: string): string =>
  suffix2mimetype[filename.substringAfterLast(".")];

/**
 * Gibt die Dateinamenendung zu einem Mimetype zurück
 * @param {string} mimetype
 * @returns {string}
 */
export const getSuffixOfMimetype = (mimetype: string): string => mimetype2suffix[mimetype];
